export { default } from "./FieldDetailsModal";
